module.exports = __webpack_public_path__ + "static/HazelResearch.9d03ee44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/HazelResearch.jpg
// module id = 393
// module chunks = 246227742792961